<template>
  <div>
    <el-row class="full_height">
      <el-col :span="4" class="positon_relative">
        <el-menu class="nav_menu" text-color="#A7CCF6"  default-active="1" active-text-color="#fff">
          <router-link :to="{name: 'interfaceSetting'}" class="link">
            <el-menu-item index="1">
              <template slot="title">
                <i class="el-icon-setting"></i>&nbsp;界面设置
              </template>
            </el-menu-item>
          </router-link>
          <router-link :to="{name: 'systemLogs'}" class="link">
            <el-menu-item index="2">
              <template slot="title">
                <i class="el-icon-document"></i>&nbsp;系统日志
              </template>
            </el-menu-item>
          </router-link>
        <router-link :to="{name: 'mailboxPush'}" class="link">
            <el-menu-item index="3">
              <template slot="title">
                <i class="el-icon-message"></i>&nbsp;邮箱推送
              </template>
            </el-menu-item>
          </router-link>

<!--          <router-link :to="{name: 'userManage'}" class="link">
             <el-menu-item index="4">
               <template slot="title">
                 <i class="el-icon-user"></i>用户管理
               </template>
            </el-menu-item>
           </router-link>-->

        </el-menu>
      </el-col>
      <el-col :span="20" class="full_height">
        <router-view class="full_height tab_content"></router-view>
      </el-col>
    </el-row>
<!--    <home-footer></home-footer>-->
  </div>
</template>

<script>
// import HomeFooter from '../../components/Footer'

export default {
  components: {
    // HomeFooter,
  },
  data() {
    return {
      code: '',
    };
  },
  mounted: function () {
    this.$router.push({"name": "interfaceSetting"})
  }
}
</script>

<style scoped>
    @import '../../assets/css/style.css';
    a{
      margin: 0;
      padding: 0;
      text-decoration: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/systemSetting/index.vue